import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';
import { buildPrivacyTermsUrl, buildUserTermsUrl } from 'locale/utils';

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  transition: all 150ms ease-in-out;
  border-radius: 12px;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 0 8px;
  flex-wrap: wrap;
`;

export const Footer = ({ className, country }: { country?: Country; className?: string }) => {
  const { locale } = useIntl();
  const termsUrl = buildUserTermsUrl(locale, country);
  const privacyUrl = buildPrivacyTermsUrl(locale, country);
  return (
    <FooterContainer className={className}>
      <Typography.Tiny>© Wolt 2014-{new Date().getFullYear()}</Typography.Tiny>
      <FooterLinks>
        <a href="https://explore.wolt.com/contact" target="_blank" rel="noreferrer">
          <Typography.Tiny>
            <FormattedMessage id="experience.contact-us" />
          </Typography.Tiny>
        </a>
        <a href={termsUrl} target="_blank" rel="noreferrer">
          <Typography.Tiny>
            <FormattedMessage id="experience.terms" />
          </Typography.Tiny>
        </a>
        <a href={privacyUrl} target="_blank" rel="noreferrer">
          <Typography.Tiny>
            <FormattedMessage id="experience.privacy" />
          </Typography.Tiny>
        </a>
      </FooterLinks>
    </FooterContainer>
  );
};
